import type { StaticImageData } from 'next/image';

import ImageProxy from '@next-image-proxy';

interface CustomStoryBannerImage {
  src: string | StaticImageData;
  width?: number;
  height?: number;
  quality?: number;
}

interface CustomStoryBannerProps {
  alt: string;
  mobile?: CustomStoryBannerImage;
  tablet?: CustomStoryBannerImage;
  desktop?: CustomStoryBannerImage;
}

const CustomStoryBanner = ({ alt, mobile, tablet, desktop }: CustomStoryBannerProps) => {
  // TODO: come up with better approach
  const mobileProps = mobile || tablet || desktop;
  const tabletProps = tablet || desktop || mobile;
  const desktopProps = desktop || tablet || mobile;

  return (
    <>
      <ImageProxy {...desktopProps} className="w-full h-auto max-xl:hidden" alt={alt} />
      <ImageProxy {...tabletProps} className="w-full h-auto max-sm:hidden xl:hidden" alt={alt} />
      <ImageProxy {...mobileProps} className="w-full h-auto sm:hidden" alt={alt} />
    </>
  );
};

export default CustomStoryBanner;
